import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";

import AppMain from "./AppMain";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Footer from "./components/Footer";
import ScrollToHash from "./components/utils/ScrollToHash";
import Article1 from "./components/articles/Article1";
import PageLoader from "./components/loader/PageLoader";
import ScrollToTop from "./components/utils/ScrollToTop";
import SeoRoute from "./components/SeoRoute";
import CreateBiodata from "./pages/CreateBiodata";
import MainLayout from "./layouts/MainLayout";
import NavBar from "./components/NavBar";
import ArticlesPage from "./pages/ArticlesPage";
import Disclaimer from "./pages/Disclaimer";
import AllTemplatesPage from "./components/AllTemplatesPage";
import { Navigate } from "react-router-dom";


function App() {
  return (
    <BrowserRouter>
    <NavBar/>
      <ScrollToTop />
      <ScrollToHash />

      {/* ✅ PAGE LAYOUT WRAPPER */}
      <Box
        minHeight="100vh"
        display="flex"
        flexDirection="column"
      >
        {/* ✅ MAIN CONTENT */}
        <Box flex={1}>
          <PageLoader>
            <Routes>
              <Route path="/templates" element={<Navigate to="/marriage-biodata-templates" replace />} />
              <Route path="/marriage-biodata-templates" element={<AllTemplatesPage />} />
              <Route path="/" element={<AppMain />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route
                path="/articles/:slug"
                element={
                  <SeoRoute canonical={window.location.href}>
                    <Article1 />
                  </SeoRoute>
                }
              />
              <Route path="/create-biodata" element={<CreateBiodata />} />
              <Route element={<MainLayout />}/>
              <Route path="/articles" element={<ArticlesPage />} />
            </Routes>
          </PageLoader>
        </Box>

        {/* ✅ FOOTER */}
        <Footer />
      </Box>
    </BrowserRouter>
  );
}

export default App;
